import { render, staticRenderFns } from "./section.vue?vue&type=template&id=fa647b1e&scoped=true&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"
import style0 from "./section.vue?vue&type=style&index=0&id=fa647b1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa647b1e",
  null
  
)

export default component.exports